import React from 'react';
import { Section } from './Section';
import { Button } from './Button';
import { ShieldCheck } from 'lucide-react';
export function OfferSection() {
  return <Section bg="white" className="border-t border-sage/10" data-id="element-126">
      <div id="offer" className="scroll-mt-8 max-w-4xl mx-auto bg-cream rounded-[2.5rem] p-8 md:p-16 shadow-2xl shadow-sage/10 relative overflow-hidden" data-id="element-127">
        {/* Decorative background elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-128"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-sage/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-129"></div>

        <div className="relative z-10 text-center" data-id="element-130">
          <h2 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-131">
            Get the full 7-DAY FACE SCULPT system today.
          </h2>
          <p className="text-xl text-charcoal/80 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-132">
            Reveal the sharper, younger, and more defined version of yourself
            that is currently hidden in plain sight.
          </p>

          <div className="bg-white inline-block rounded-2xl p-8 mb-10 shadow-lg border border-sage/10 relative" data-id="element-133">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-red-500 text-white text-xs font-bold uppercase tracking-widest px-5 py-1.5 rounded-full shadow-md animate-pulse" data-id="element-134">
              🔥 62% OFF — Limited Time
            </div>
            <div className="text-sm font-semibold text-sage uppercase tracking-widest mb-3 mt-2" data-id="element-135">
              Special Price Today
            </div>
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-136">
              <span className="text-3xl font-serif text-charcoal/40 line-through" data-id="element-137">
                $17.00 USD
              </span>
              <span className="text-6xl font-serif text-charcoal" data-id="element-138">
                $6.39 <span className="text-2xl" data-id="element-139">USD</span>
              </span>
            </div>
            <div className="text-charcoal/60 text-sm" data-id="element-140">
              One-time payment. Instant digital access.
            </div>
          </div>

          <div data-id="element-141">
            <a href="https://www.puntovital.lat/cart/45451724292198:1" target="_blank" rel="noopener noreferrer" data-id="element-142">
              <Button className="text-lg px-12 py-5 w-full md:w-auto" data-id="element-143">
                REVEAL MY SCULPTED FACE NOW
              </Button>
            </a>

            <div className="flex items-center justify-center mt-6 text-charcoal/60 text-sm" data-id="element-144">
              <ShieldCheck className="w-4 h-4 mr-2 text-sage" data-id="element-145" />
              Instant Download. 100% Secure Checkout.
            </div>
          </div>
        </div>
      </div>
    </Section>;
}